/**
 * Umsätze-Tab der Buchhaltungsseite
 */

import {
  Upload, CheckCircle, XCircle, Euro, FileSpreadsheet
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export function UmsaetzeTab({
  umsaetze, kategorien, handleKategorisieren,
  openChildTab, selectedKlient, konten
}) {
  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
        <p className="text-sm text-slate-500">{umsaetze.length} Umsätze</p>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={() => openChildTab('/schnellerfassung/csv-import', { title: 'CSV/MT940 Import', forceNew: true, params: { klientId: selectedKlient, konten } })}>
            <FileSpreadsheet className="w-4 h-4 mr-2" /> CSV/MT940 Import
          </Button>
          <Button variant="outline" size="sm" onClick={() => openChildTab('/schnellerfassung/kontoauszug', { title: 'Kontoauszug Upload', forceNew: true, params: { klientId: selectedKlient, konten } })}>
            <Upload className="w-4 h-4 mr-2" /> PDF Upload
          </Button>
        </div>
      </div>
      {umsaetze.length > 0 ? (
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-left">
                <tr>
                  <th className="px-4 py-2 text-slate-500 font-medium">Datum</th>
                  <th className="px-4 py-2 text-slate-500 font-medium">Verwendungszweck</th>
                  <th className="px-4 py-2 text-slate-500 font-medium">Kategorie</th>
                  <th className="px-4 py-2 text-slate-500 font-medium text-right">Betrag</th>
                  <th className="px-4 py-2 text-slate-500 font-medium">Beleg</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {umsaetze.slice(0, 100).map(u => (
                  <tr key={u.id} className="hover:bg-slate-50">
                    <td className="px-4 py-2 text-slate-700 whitespace-nowrap">
                      {u.datum ? new Date(u.datum).toLocaleDateString('de-DE') : ''}
                    </td>
                    <td className="px-4 py-2 text-slate-700 max-w-xs truncate">{u.verwendungszweck || '-'}</td>
                    <td className="px-4 py-2">
                      <Select 
                        value={u.kategorie || 'sonstiges'} 
                        onValueChange={(v) => handleKategorisieren(u.id, v)}
                      >
                        <SelectTrigger className="h-8 w-40 text-xs">
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          {kategorien.map(k => (
                            <SelectItem key={k.id} value={k.id}>{k.name}</SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </td>
                    <td className={`px-4 py-2 text-right font-medium whitespace-nowrap ${u.betrag >= 0 ? 'text-green-700' : 'text-red-700'}`}>
                      {u.betrag >= 0 ? '+' : ''}{u.betrag.toLocaleString('de-DE', { minimumFractionDigits: 2 })} €
                    </td>
                    <td className="px-4 py-2">
                      {u.beleg_status === 'zugeordnet' ? (
                        <CheckCircle className="w-4 h-4 text-green-500" />
                      ) : (
                        <XCircle className="w-4 h-4 text-slate-300" />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <Card>
          <CardContent className="py-8 text-center">
            <Euro className="w-12 h-12 mx-auto text-slate-300 mb-3" />
            <p className="text-slate-500">Keine Umsätze vorhanden</p>
            <p className="text-sm text-slate-400 mt-1">Importieren Sie Transaktionen oder verbinden Sie ein Konto</p>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
